import type { FileEntry } from '@/types/SixDetail.types';
import type { FileMetadata } from '@/types/poc/helia';

type FileAccessShape = Pick<FileEntry, 'kind' | 'encryptedFileKeys'> & Partial<Pick<FileMetadata, 'decryptionCIDS' | 'recipientEncryption'>>;

export function userHasFileKey(file: FileAccessShape, userId?: string): boolean {
  if (file.kind === 'folder') return false;
  if (typeof userId !== 'string' || userId.trim().length === 0) return true;

  if (Array.isArray(file.recipientEncryption) && file.recipientEncryption.length > 0) {
    return file.recipientEncryption.some((recipient) => recipient.recipientId === userId);
  }

  if (Array.isArray(file.decryptionCIDS) && file.decryptionCIDS.length > 0) {
    return file.decryptionCIDS.some((entry) => entry.userId === userId);
  }

  if (file.encryptedFileKeys !== undefined && Object.keys(file.encryptedFileKeys).length > 0) {
    return userId in file.encryptedFileKeys;
  }

  return true;
}

export function canDownloadFile(file: FileAccessShape & { cid?: string }): boolean {
  return file.kind === 'file' && typeof file.cid === 'string' && file.cid.trim().length > 0;
}
